/* eslint-disable func-names */
const marked = require('marked');

module.exports = function (env) {
  env.addFilter('markdown', str => marked.parse(str));
};
